module.exports = __webpack_public_path__ + "static/images/components/ChallengeContent/components/Label/images/rhomb.a189106f.png";


//////////////////
// WEBPACK FOOTER
// ./components/ChallengeContent/components/Label/images/rhomb.png
// module id = 2590
// module chunks = 11